import type { FC } from "react";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import ModalContentUserApproved from "app/pages/sales-intelligence/pages/manage-signals/components/ApplyTopicModal/modalContent/ModalContentUserApproved";
import { translate } from "app/filters/i18nFilter";
import { intentUserApprovalModalConfig } from "./styles";

type IntentUserApprovalModalProps = {
    isOpen: boolean;
    onClick: () => void;
};
const IntentUserApprovalModal: FC<IntentUserApprovalModalProps> = ({ isOpen, onClick }) => {
    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={intentUserApprovalModalConfig}
        >
            <ModalContentUserApproved
                title={translate("si.intent.modal.header.user-approved")}
                subDescription={translate("si.intent.modal.sub-description.user-approved")}
                description={translate("si.intent.modal.description.user-approved")}
                onClick={onClick}
                buttonText={translate("si.intent.modal.btn.got-it")}
            />
        </ProModal>
    );
};

export default IntentUserApprovalModal;
